// THIS FILE IS AUTO-GENERATED BY "@udemy-v2/nextjs-pagekeys"
// DO NOT EDIT THIS FILE DIRECTLY. ENTRIES ARE ORDERED BY ROUTE SPECIFICITY (static > dynamic > catch-all).
// Reason: Consumers (Next.js headers/rewrites and getPageKeyForPathname) use first-match semantics, so specific
// routes must appear before generic catch-alls to avoid shadowing (e.g., 404 capturing all).

import { PageKeyDefinition } from '@udemy-v2/nextjs-pagekeys';

export const pageKeyDefinitions: PageKeyDefinition[] = [
    {
        pageKey: "instructor_profile_basic_information",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/instructor/profile/basic-information/",
        routePatternNextJS: "/:lang/instructor/profile/basic-information/",
        filePath: "src/app/[lang]/instructor/profile/basic-information/page.tsx"
    },
    {
        pageKey: "instructor_profile_community_settings",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/instructor/profile/community-settings/",
        routePatternNextJS: "/:lang/instructor/profile/community-settings/",
        filePath: "src/app/[lang]/instructor/profile/community-settings/page.tsx"
    },
    {
        pageKey: "instructor_profile_preview",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/instructor/profile/preview/",
        routePatternNextJS: "/:lang/instructor/profile/preview/",
        filePath: "src/app/[lang]/instructor/profile/preview/page.tsx"
    },
    {
        pageKey: "instructor_profile_privacy",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/instructor/profile/privacy/",
        routePatternNextJS: "/:lang/instructor/profile/privacy/",
        filePath: "src/app/[lang]/instructor/profile/privacy/page.tsx"
    },
    {
        pageKey: "example_isr_page",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/examples/isr-page/",
        routePatternNextJS: "/:lang/examples/isr-page/",
        filePath: "src/app/[lang]/examples/isr-page/page.tsx"
    },
    {
        pageKey: "example_sentry_page",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/examples/sentry-example-page/",
        routePatternNextJS: "/:lang/examples/sentry-example-page/",
        filePath: "src/app/[lang]/examples/sentry-example-page/page.tsx"
    },
    {
        pageKey: "example_ssr_page",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/examples/ssr-page/",
        routePatternNextJS: "/:lang/examples/ssr-page/",
        filePath: "src/app/[lang]/examples/ssr-page/page.tsx"
    },
    {
        pageKey: "instructor_profile",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/instructor/profile/",
        routePatternNextJS: "/:lang/instructor/profile/",
        filePath: "src/app/[lang]/instructor/profile/page.tsx"
    },
    {
        pageKey: "instructor_profile_preview_frame",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/user/preview-frame/",
        routePatternNextJS: "/:lang/user/preview-frame/",
        filePath: "src/app/[lang]/user/preview-frame/page.tsx"
    },
    {
        pageKey: "examples_page",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/examples/",
        routePatternNextJS: "/:lang/examples/",
        filePath: "src/app/[lang]/examples/page.tsx"
    },
    {
        pageKey: "welcome",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/",
        routePatternNextJS: "/:lang/",
        filePath: "src/app/[lang]/page.tsx"
    },
    {
        pageKey: "public_profile",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/user/:urlTitle/",
        routePatternNextJS: "/:lang/user/:urlTitle/",
        filePath: "src/app/[lang]/user/[urlTitle]/page.tsx"
    },
    {
        pageKey: "example_buggy_page",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/examples/buggy-page/{/*slug}/",
        routePatternNextJS: "/:lang/examples/buggy-page/:slug*/",
        filePath: "src/app/[lang]/examples/buggy-page/[[...slug]]/page.tsx"
    },
    {
        pageKey: "404",
        routePattern: "{/frontends-instructor-profile-tooling}{/:lang}/*notFound/",
        routePatternNextJS: "/:lang/:notFound*/",
        filePath: "src/app/[lang]/[...notFound]/page.tsx"
    }
];
